import { render, staticRenderFns } from "./manges.vue?vue&type=template&id=2d35fea9&scoped=true"
import script from "./manges.vue?vue&type=script&lang=js"
export * from "./manges.vue?vue&type=script&lang=js"
import style0 from "./manges.vue?vue&type=style&index=0&id=2d35fea9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d35fea9",
  null
  
)

export default component.exports